import React, { useRef, useState } from "react";
import { CiImageOn } from "react-icons/ci";
import { useProductForm } from "../../contexts/ProductFormContext";
import Lottie from "lottie-react";
import loading from "../../animations/loading.json";
import { IoIosCloseCircle } from "react-icons/io";
import { ImBin } from "react-icons/im";
import { TiPencil } from "react-icons/ti";
import { useFileUpload } from "../../hooks/useFileUpload";
import { API } from "../../configs/endpoints";

type ImageType = {
  url: string;
  public_id: string;
};

type VariantType = {
  name: string;
  sku: string;
  price: number;
  discountPrice: number;
  stock: number;
  images: ImageType[];
  isActive: boolean;
};
export const VariantTab = () => {
  const { product, setProduct } = useProductForm();
  const [variant, setVariant] = useState<VariantType>({
    name: "",
    sku: "",
    price: 0,
    discountPrice: 0,
    stock: 0,
    images: [],
    isActive: true,
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setVariant((prev) => ({
      ...prev,
      [name]:
        type === "radio"
          ? value === "true"
          : type === "number"
            ? Number(value)
            : value,
    }));
  };

  const validVariant =
    variant.name.trim() !== "" &&
    variant.sku.trim() !== "" &&
    variant.stock > 0 &&
    variant.price > 0 &&
    variant.images.length > 0;

  const inputRef = useRef<HTMLInputElement>(null);
  const { upload, isUploading: isChooseImage } = useFileUpload<{
    images: ImageType[];
  }>({
    endpoint: API.variant.upload,
    kind: "image",
    maxFiles: 10,
  });
  const handleChooseImages = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const result = await upload(e.target.files);
    e.target.value = "";
    if (result.ok && result.data?.images) {
      setVariant((prev) => ({
        ...prev,
        images: [...prev.images, ...result.data!.images],
      }));
    }
  };

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [indexEdit, setIndexEdit] = useState<number | null>(null);
  return (
    <div className="p-5 border rounded-xl border-gray-100 bg-white space-y-2">
      <h2 className="text-lg text-black font-semibold">
        Giá bán, Kho hàng và Biến thể
      </h2>
      <div className="space-y-2">
        <p className="text-xs text-gray-700">
          Sản phẩm phải có ít nhất 1 biến thể.
        </p>
        <div className="space-y-2 border border-gray-200 rounded-xl p-5">
          {isEdit ? (
            <p className="text-lg text-gray-700 font-medium">Sửa biến thể</p>
          ) : (
            <p className="text-lg text-gray-700 font-medium">Thêm biến thể</p>
          )}

          {/* form variant */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm text-gray-700 font-semibold">
                Tên biến thể
              </label>
              <input
                type="text"
                name="name"
                value={variant.name}
                onChange={handleChange}
                className="w-full p-2 focus:outline-none focus:border-blue-500 rounded-lg border border-gray-200 placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
                placeholder="Thân máy"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm text-gray-700 font-semibold">
                Mã sản phẩm (SKU)
              </label>
              <input
                type="text"
                name="sku"
                value={variant.sku}
                onChange={handleChange}
                className="w-full p-2 focus:outline-none focus:border-blue-500 rounded-lg border border-gray-200 placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
                placeholder="KPSMOIKEO"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm text-gray-700 font-semibold">
                Giá
              </label>
              <input
                type="number"
                name="price"
                value={variant.price}
                onChange={handleChange}
                className="w-full p-2 focus:outline-none focus:border-blue-500 rounded-lg border border-gray-200 placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
                placeholder="1.000.000"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm text-gray-700 font-semibold">
                Giá đặc biệt
              </label>
              <input
                type="number"
                name="discountPrice"
                value={variant.discountPrice}
                onChange={handleChange}
                className="w-full p-2 focus:outline-none focus:border-blue-500 rounded-lg border border-gray-200 placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
                placeholder="900.000"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm text-gray-700 font-semibold">
                Tồn kho
              </label>
              <input
                type="number"
                name="stock"
                value={variant.stock}
                onChange={handleChange}
                className="w-full p-2 focus:outline-none focus:border-blue-500 rounded-lg border border-gray-200 placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
                placeholder="10"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm text-gray-700 font-semibold">
                Trạng thái
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  name="isActive"
                  value="true"
                  checked={variant.isActive === true}
                  onChange={handleChange}
                  className="cursor-pointer accent-green-500"
                />
                <p className="text-sm text-green-500">Kinh doanh</p>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  name="isActive"
                  value="false"
                  checked={variant.isActive === false}
                  onChange={handleChange}
                  className="cursor-pointer accent-red-500"
                />
                <p className="text-sm text-red-500">Ngừng kinh doanh</p>
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <label className="block text-sm text-gray-700 font-semibold">
              Ảnh biến thể
            </label>
            <div className="flex items-center gap-2 border border-gray-200 w-full p-2">
              <input
                type="file"
                className="hidden"
                ref={inputRef}
                multiple
                onChange={handleChooseImages}
              />
              {isChooseImage ? (
                <Lottie animationData={loading} loop className="h-15 w-15" />
              ) : (
                <button
                  type="button"
                  onClick={() => {
                    inputRef.current?.click();
                  }}
                  className="h-15 w-15 flex items-center text-gray-700 hover:text-blue-500 justify-center border border-gray-500 border-dashed rounded-lg cursor-pointer hover:border-blue-500 transition-colors duration-300"
                >
                  <CiImageOn />
                </button>
              )}
              <div className="flex-1 flex max-w-80 scrollbar-custom items-center gap-2 overflow-x-auto p-2">
                {variant.images.length > 0 &&
                  variant.images.map((image) => (
                    <div
                      className="w-15 h-15 shrink-0 relative"
                      key={image.public_id}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          setVariant((prev) => ({
                            ...prev,
                            images: prev.images.filter(
                              (item) => item.public_id !== image.public_id,
                            ),
                          }));
                        }}
                        className="absolute text-lg text-red-500 cursor-pointer hover:text-red-600 -top-1 -right-2"
                      >
                        <IoIosCloseCircle />
                      </button>
                      <img
                        src={image.url}
                        alt="Ảnh biến thể"
                        className="w-full h-full rounded-lg border border-gray-200 object-cover"
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 justify-end">
            <button
              type="button"
              onClick={() => {
                setVariant({
                  name: "",
                  sku: "",
                  price: 0,
                  discountPrice: 0,
                  stock: 0,
                  images: [],
                  isActive: true,
                });
                setIsEdit(false);
              }}
              className="p-2 bg-red-500 text-white text-sm rounded-lg cursor-pointer hover:bg-red-600"
            >
              Hủy
            </button>
            {isEdit ? (
              <button
                disabled={!validVariant}
                type="button"
                onClick={() => {
                  setProduct((prev) => ({
                    ...prev,
                    variants: prev.variants.map((v, i) =>
                      i === indexEdit ? { ...v, ...variant } : v,
                    ),
                  }));
                  setVariant({
                    name: "",
                    sku: "",
                    price: 0,
                    discountPrice: 0,
                    stock: 0,
                    images: [],
                    isActive: true,
                  });
                  setIsEdit(false);
                }}
                className={`p-2 text-sm rounded-lg cursor-pointer ${validVariant ? "bg-green-500 text-white hover:bg-green-600 pointer-events-auto" : "pointer-events-none bg-gray-200 text-gray-400"}`}
              >
                Lưu
              </button>
            ) : (
              <button
                disabled={!validVariant}
                type="button"
                onClick={() => {
                  setProduct((prev) => ({
                    ...prev,
                    variants: [...prev.variants, variant],
                  }));
                  setVariant({
                    name: "",
                    sku: "",
                    price: 0,
                    discountPrice: 0,
                    stock: 0,
                    images: [],
                    isActive: true,
                  });
                }}
                className={`p-2 text-sm rounded-lg cursor-pointer ${validVariant ? "bg-green-500 text-white hover:bg-green-600 pointer-events-auto" : "pointer-events-none bg-gray-200 text-gray-400"}`}
              >
                Thêm biến thể
              </button>
            )}
          </div>
        </div>

        <div className="w-full overflow-x-auto scrollbar-custom">
          <table className="w-full min-w-175">
            <thead className="border border-gray-200">
              <tr className="border border-gray-200 bg-gray-50/80">
                <th>
                  <p className="text-sm text-gray-700 font-semibold p-2 text-center">
                    Tên biến thể
                  </p>
                </th>
                <th>
                  <p className="text-sm text-gray-700 font-semibold p-2 text-center">
                    Ảnh
                  </p>
                </th>
                <th>
                  <p className="text-sm text-gray-700 font-semibold p-2 text-center">
                    Mã sản phẩm (SKU)
                  </p>
                </th>
                <th>
                  <p className="text-sm text-gray-700 font-semibold p-2 text-center">
                    Giá
                  </p>
                </th>
                <th>
                  <p className="text-sm text-gray-700 font-semibold p-2 text-center">
                    Giá đặc biệt
                  </p>
                </th>
                <th>
                  <p className="text-sm text-gray-700 font-semibold p-2 text-center">
                    Tồn kho
                  </p>
                </th>
                <th>
                  <p className="text-sm text-gray-700 font-semibold p-2 text-center">
                    Trạng thái
                  </p>
                </th>
                <th>
                  <p className="text-sm text-gray-700 font-semibold p-2 text-center">
                    Thao tác
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              {product.variants.length > 0 ? (
                product.variants.map((item, index) => (
                  <tr
                    key={index}
                    className="border-t border-gray-100 hover:bg-gray-50/50 transition-colors"
                  >
                    <td>
                      <p className="p-2 text-sm text-gray-700 text-center">
                        {item.name}
                      </p>
                    </td>
                    <td>
                      <div className="flex items-center justify-center p-2">
                        <img
                          src={item.images?.[0]?.url}
                          alt="Ảnh biến thể"
                          className="h-15 w-15 rounded-lg object-cover border border-gray-200"
                        />
                      </div>
                    </td>
                    <td>
                      <p className="p-2 text-sm text-gray-700 text-center">
                        {item.sku}
                      </p>
                    </td>
                    <td>
                      <p className="p-2 text-sm text-gray-700 text-center">
                        {item.price}
                      </p>
                    </td>
                    <td>
                      <p className="p-2 text-sm text-gray-700 text-center">
                        {item.discountPrice}
                      </p>
                    </td>
                    <td>
                      <p className="p-2 text-sm text-gray-700 text-center">
                        {item.stock}
                      </p>
                    </td>
                    <td>
                      {item.isActive === true ? (
                        <p className="text-xs font-medium px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-600">
                          Đang kinh doanh
                        </p>
                      ) : (
                        <p className="p-2 text-xs font-medium px-2.5 py-1 rounded-full bg-red-50 text-red-600 text-center inline-block">
                          Ngừng kinh doanh
                        </p>
                      )}
                    </td>
                    <td>
                      <div className="flex items-center gap-2 justify-center">
                        <button
                          className="text-xl text-gray-700 hover:text-blue-500 transition-colors duration-300 cursor-pointer"
                          type="button"
                          onClick={() => {
                            setVariant({
                              name: item.name,
                              discountPrice: item.discountPrice,
                              images: item.images,
                              isActive: item.isActive,
                              price: item.price,
                              sku: item.sku,
                              stock: item.stock,
                            });
                            setIsEdit(true);
                            setIndexEdit(index);
                          }}
                        >
                          <TiPencil />
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setProduct((prev) => ({
                              ...prev,
                              variants: prev.variants.filter(
                                (_, i) => i !== index,
                              ),
                            }))
                          }
                          className="text-lg text-gray-700 hover:text-red-500 transition-colors duration-300 cursor-pointer"
                        >
                          <ImBin />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="border border-gray-200">
                  <td colSpan={8}>
                    <p className="text-sm p-2 text-center text-gray-700">
                      Chưa có thông tin nào
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
